// @flow

import * as React from 'react';
import classNames from 'classnames';
import toUIAddress from '@active/awe-ui-core/lib/dataTransfer/address';
import AddressStatic from 'react-aaui/lib/form/AddressStatic';
import compact from 'lodash/compact';
import Maybe, { maybe } from '@active/awe-ui-core/lib/fp/Maybe';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { L10n } from 'type/type';
import { NavLink } from 'react-router-dom';
import SocialShares from '@active/awe-ui-core/lib/components/SocialShares';

import './PersonalProfile.scss';

type Props = {
  personHref: ?string,
  avatar: string,
  layout: string,
  firstName: string,
  lastName: string,
  gender: string,
  age: number,
  address: Object,
  team: string,
  showTeam: ?boolean,
  locale: string,
  l10n: L10n,
  socialSharesConfig: Object,
  isVirtual: Boolean
}

export const PersonalProfile = ({
  personHref, avatar, layout = 'horizontal', firstName, lastName, gender, age, address = {}, team, showTeam, locale, l10n, socialSharesConfig = {}, isVirtual,
}: Props) => {
  const displayAge = maybe(null, () => {
    return `${l10n.formatMessage('global.participant.age')} ${age}`;
  }, Maybe.of(age));

  const personInfoName = personHref
    ? (<NavLink className="personal-info__name" to={personHref}>
      {firstName}
      {' '}
      {lastName}
    </NavLink>)
    : (<div className="personal-info__name">
      {firstName}
      {' '}
      {lastName}
    </div>);
  return (
    <div className={classNames('personal-profile', layout)}>
      <i className={classNames('personal-avatar', avatar)} />
      <div className="personal-info">
        { personInfoName }
        <div className="personal-info__detail">
          {
            compact([ gender, displayAge ]).join(' | ')
          }
        </div>
        { !isVirtual && <div>
          <AddressStatic address={toUIAddress(address)} nowrap locale={locale} />
        </div> }
        { showTeam && team
          && <div className="personal-info__team-info">
            <div className="personal-info__team-info__icon">
              <i className="iconfont icon-group-thin" />
              <div className="personal-info__team-info__title">
                { l10n.formatMessage('page.participant.participantHeader.team') }
              </div>
            </div>
            <div className="personal-info__team-info__detail">
              { team }
            </div>
          </div>
        }
        {
          Object.keys(socialSharesConfig).length > 0
            && <div className="personal-info--social-shares__wrapper">
              <SocialShares {...socialSharesConfig} />
            </div>
        }
      </div>
    </div>);
};

export default injectL10n()(PersonalProfile);
